import { useSelector } from 'react-redux';
import { getAlgoListDataCached } from '../stores/algos-list/getters';

function useAlgosDataFiltered(day) {
  const algos =
    useSelector((state) => {
      const { algos = [] } =
        getAlgoListDataCached(state).find((d) => d.day === day) || [];

      return algos;
    }) || [];

  return algos;
}

export default useAlgosDataFiltered;
